import React from "react";
// Components
import { DownloadContainer } from "./styles";
import DownloadCSV from "./sections/downloadCSV";
import DownloadPDF from "./sections/downloadPDF";

const DownloadFiles = ({ sessionsData, plotsRef }) => {
  return (
    <DownloadContainer>
      <DownloadPDF plotsRef={plotsRef} />
      <DownloadCSV sessionsData={sessionsData} />
    </DownloadContainer>
  );
};

export default DownloadFiles;
